import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadFileActions } from '../store/ducks/download';
import type { RootState } from '../store';

export function useDownloadUri(fileKey: string) {
  const dispatch = useDispatch();

  const data = useSelector((state: RootState) => state.downloadFile.data);
  const loading = useSelector((state: RootState) => state.downloadFile.loading);

  useEffect(() => {
    if (!fileKey) return;
    dispatch(
      DownloadFileActions.request(
        fileKey,
        () => {},
        () => console.warn('Erro ao tentar buscar URI')
      )
    );
  }, [dispatch, fileKey]);

  return { uri: data?.uri || '', loading };
}
